import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { TranslationDetail } from '../entities/translation-detail';

@Injectable()
export class TranslationDetailService extends BaseCrudService<TranslationDetail> {

  public uri = '/api/translationDetail/';

  constructor(injector: Injector) {
      super(injector);
     //console.log('Instance TerminationReasonService');
  }

  buildSentence(entity?: TranslationDetail, event?: LazyLoadEvent): HttpParams {
      if (entity) {
          let query = entity.text ? 'text'
              + QueryOperator.Contain + entity.text
              + QueryOperator.Split : QueryOperator.Empty;
          query = query.concat(
              entity.language ? 'language.id'
              + QueryOperator.Equal + entity.language.id
              + QueryOperator.Split : QueryOperator.Empty
          );
          query = query.concat(
            entity.translationText ? 'translationText.name'
            + QueryOperator.Contain + entity.translationText.name
            + QueryOperator.Split : QueryOperator.Empty
        );
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
      }

      if (event) {
          const page = ((event.first + event.rows) / event.rows - 1 ).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
      }
      return this.httpParams;
  }
 
}



// WEBPACK FOOTER //
// ./src/app/core/services/translation-detail.service.ts